import React from 'react';

interface ImageMetadataProps {
  metadata: {
    width: number;
    height: number;
    type: string;
    size: number;
    lastModified?: number;
  } | null;
}

const ImageMetadata: React.FC<ImageMetadataProps> = ({ metadata }) => {
  if (!metadata) return null;

  const formatDate = (timestamp: number) => {
    return new Date(timestamp).toLocaleString();
  };

  return (
    <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-3 mt-2 text-sm">
      <div className="grid grid-cols-2 gap-2">
        <div className="text-gray-600 dark:text-gray-300">Dimensions:</div>
        <div className="text-gray-800 dark:text-gray-100">
          {metadata.width} × {metadata.height} pixels
        </div>
        
        <div className="text-gray-600 dark:text-gray-300">Format:</div>
        <div className="text-gray-800 dark:text-gray-100">
          {metadata.type.toUpperCase()}
        </div>
        
        <div className="text-gray-600 dark:text-gray-300">File Size:</div>
        <div className="text-gray-800 dark:text-gray-100">
          {(metadata.size / 1024).toFixed(2)} KB
        </div>
        
        {metadata.lastModified && (
          <>
            <div className="text-gray-600 dark:text-gray-300">Last Modified:</div>
            <div className="text-gray-800 dark:text-gray-100">
              {formatDate(metadata.lastModified)}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ImageMetadata; 